import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import { Navigate, Routes} from 'react-router-dom'
import {deleteUser} from './redux/AuthSlice'
import { LayoutSplashScreen } from '../../../_metronic/layout/core'


export function Logout() {

  const [loggingOut, setLoggingOut] = useState<boolean>(true)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(deleteUser(undefined))
    localStorage.clear();
    setLoggingOut(false)
  }, [])

  useEffect(() => {
    !loggingOut && document.location.reload()
  }, [loggingOut])

  return (
    <>
    {loggingOut ? <LayoutSplashScreen /> : 
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>}
  </>)
}
